import React, { useContext, useReducer } from 'react'
import reducer from '../reducers/website_reducer'

import {
    SHOW_HIDE_GALLERY,
    SET_CURRENT_IMAGE,
    CHANGE_IMAGE_GALLERY,
  } from '../utils/actions'


  const initialState = {
    galleryON: false,
    currentImg: 0
  }

  const WebsiteContext = React.createContext();

  export const WebsiteProvider = ({children}) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const showHideGallery = () => {
        dispatch({type: SHOW_HIDE_GALLERY });
    }
    const setCurrentImg = (img) => {
        dispatch({type: SET_CURRENT_IMAGE, payload: img});
    }
    const changeImageGallery = (direction) => {
          dispatch({type: CHANGE_IMAGE_GALLERY, payload: direction });
      }


   return (
       <WebsiteContext.Provider value={{ ...state, changeImageGallery, showHideGallery, setCurrentImg } }>
         {children}
       </WebsiteContext.Provider>
     )
}

// make sure use
export const useWebsiteContext = () => {
    return useContext(WebsiteContext)
  }
